import { Component, ComponentRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import { filter, from, map, toArray } from 'rxjs';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';

declare let $: any


@Component({

  selector: 'app-roles-role-accesses',

  templateUrl: './roles-role-accesses.component.html',

  styleUrls: ['./roles-role-accesses.component.css']

})

export class RolesRoleAccessesComponent implements OnInit {

  lst_Roles: any[] = [];

  lst_Search: any[] = [];

  lst_Search2: any[] = [];

  lst_Access: any[] = [];

  bEditMode: boolean = false;

  mdl_Role: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    strComment: new FormControl('', Validators.required),

    iSystemUser_Group: new FormControl(''),

    strXenotakAbility: new FormControl(''),

    index_: new FormControl(''),

  });

  constructor(

    private _tooltip: NotificationService,

    private _formBuilder: FormBuilder,

    private _gurd: GurdServiceService,

    public _other: OtherService,

    private _router: Router,

  ) { }

  ngOnInit(): void {

    this.getRoles();

  }

  getRoles = async () => {

    var model = this._other.stringNumberToNumber({

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

    })

    this._other.Showspinner();

    const resp = await axios.post(`SystemUser_Group_List`, this._other.stringNumberToNumber(model));

    let res = JSON.parse(resp.data);

    this._other.nonespinner();

    this.lst_Roles = res;

    this.lst_Search = res;

  }

  getRoleAccess = async (item: any) => {

    Object.keys(item).forEach(key => {

      this.mdl_Role.get(key)?.setValue(item[key])

    })

    this._other.Showspinner();

    const resp = await axios.post(`SystemUser_Group_Ability_List`, this._other.stringNumberToNumber(this.mdl_Role.value));

    this._other.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Access = res;
    
    this.lst_Search2 = res;

    $("#Access_Modal").modal('show')


  }

  openModal(item: any = {}, isEdit: boolean = false, index: number = -1) {

    if (!isEdit) {

      this.mdl_Role.patchValue({

        strComment: '',

        iSystemUser_Group: '',

        index_: ''

      })

      this.bEditMode = false;

      $("#Role_Modal").modal('show')

    }

    else {

      this.mdl_Role.get('index_')?.setValue(index);

      Object.keys(item).forEach(key => {

        this.mdl_Role.get(key)?.setValue(item[key])

      })

      this.bEditMode = true;

      $("#Role_Modal").modal('show')


    }

  }

  async submitRole() {

    if (this.mdl_Role.invalid) return this._tooltip.showError('عنوان نقش را وارد کنید');

    // اگر در حالت ثبت بود

    if (!this.bEditMode) {

      this._other.Showspinner();

      const resp = await axios.post(`SystemUser_Group_Save`, this._other.stringNumberToNumber(this.mdl_Role.value));

      this._other.nonespinner();

      let res = JSON.parse(resp.data);

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.lst_Roles.push(res[0]);

      this._tooltip.showSuccess('با موفقیت ذخیره شد')

      $("#Role_Modal").modal('hide');

    }

    // اگر در حالت ویرایش بود

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._other.Showspinner();

              const resp = await axios.post(`SystemUser_Group_Edit`, this._other.stringNumberToNumber(this.mdl_Role.value));

              this._other.nonespinner();

              let res = JSON.parse(resp.data);

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_Roles[this.mdl_Role.get('index_')?.value] = res[0];

              this._tooltip.showSuccess('با موفقیت ویرایش شد')

              $("#Role_Modal").modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  remove_Role(item: any, index: number) {

    $.confirm({

      title: `آیا از حذف این نقش اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this.mdl_Role.get('index_')?.setValue(index);

            Object.keys(item).forEach(key => {

              this.mdl_Role.get(key)?.setValue(item[key])

            })

            this._other.Showspinner();

            const resp = await axios.post(`SystemUser_Group_Delete`, this._other.stringNumberToNumber(this.mdl_Role.value));

            this._other.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this.lst_Roles.splice(this.mdl_Role.get('index_')?.value, 1);

            this._tooltip.showSuccess('با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  addOrRemoveAccess = async (id: any) => {

    this.mdl_Role.get('strXenotakAbility')?.setValue(id);

    this._other.Showspinner();

    const resp = await axios.post(`SystemUser_Group_Ability_AddOrRemove`, this._other.stringNumberToNumber(this.mdl_Role.value));

    this._other.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

  }

  addAllAccess = async (bAddOrRemove: 0 | 1) => {

    this._other.Showspinner();

    let strXenotakAbility: string[] = []

    from(this.lst_Access).pipe(map((el: any) => el.strXenotakAbility), toArray()).subscribe({ next: val => strXenotakAbility = val })

    var model = {

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iSystemUser_Group: this.mdl_Role.get('iSystemUser_Group')?.value,

      bAddOrRemove: bAddOrRemove,

      lststrXenotakAbility: strXenotakAbility

    }

    const resp: any = await axios.post(`SystemUser_Group_Ability_AddOrRemoveAll`, this._other.stringNumberToNumber(model));

    this._other.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

    $('#Access_Modal').modal('hide')

  }

  filter_list(val: any) {

    this.lst_Roles = this.lst_Search.filter((el: any) => {

      return el.strComment.includes(val.value) 

    });

    if (val.value.trim() == '') {

      this.lst_Roles = this.lst_Search;

    }

  }

  filter_list2(val: any) {

    this.lst_Access = this.lst_Search2.filter((el: any) => {

      return el.strComment.includes(val.value) 

    });

    if (val.value.trim() == '') {

      this.lst_Access = this.lst_Search2;

    }

  }


}
